import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_FLIGHTS_SERVICE_BASE,
  async loadFlightAlerts(hoursPast) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetFlightAlerts?hoursPast=${hoursPast}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadDivertedFlightAlerts(hoursPast) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetDivertedFlightAlerts?hoursPast=${hoursPast}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
